import * as Comlink from "comlink";
import { set, forEach, get } from "lodash";
import Worker_Validation from "worker-loader!./Worker_validation";
export const validation = async (schema, data, handleError) => {
    const newData = checkNumbers(schema, data);
    const worker = new Worker_Validation();
    const obj = Comlink.wrap(worker);
    let ajvObj = await obj.ajvValidation(schema, newData);
    handleError(ajvObj.errors);
    obj[Comlink.releaseProxy]();
    worker.terminate();
};
export const checkNumbers = (schema, data, path) => {
    forEach(schema.properties, (item, index) => {
        if (item.type === "object") {
            const p = path ? `${path}.${index}` : `${index}`;
            checkNumbers(item, data, p);
        }
        else if (item.type === "array") {
            const p = path ? `${path}.${item.key}` : `${item.key}`;
            if (get(data, p).length > 0) {
                forEach(get(data, p), (_, i) => checkNumbers(item.items, data, `${p}[${i}]`));
            }
        }
        else if (item.type === "number" || item.type === "integer") {
            const p = path ? `${path}.${item.key}` : `${item.key}`;
            set(data, p, Number(get(data, p)));
        }
    });
    return data;
};
//# sourceMappingURL=validation.js.map